var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "url(#b)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 226,
    fill: "url(#c)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.164 183.141c0-34.32 27.822-62.141 62.141-62.141h1.942c34.319 0 62.14 27.821 62.14 62.141v44.663h-25.73v-43.207c0-20.645-16.735-37.381-37.381-37.381s-37.382 16.736-37.382 37.381v43.207h-25.73v-44.663Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165 247.225c0-10.725 8.694-19.419 19.419-19.419h143.7c10.725 0 19.419 8.694 19.419 19.419v88.356c0 10.725-8.694 19.419-19.419 19.419h-143.7C173.694 355 165 346.306 165 335.581v-88.356Zm98.361 51.74c8.584-2.945 14.755-11.087 14.755-20.67 0-12.065-9.781-21.846-21.847-21.846-12.065 0-21.846 9.781-21.846 21.846 0 9.583 6.17 17.725 14.755 20.67a7.282 7.282 0 0 0-.191 1.662v15.05a7.282 7.282 0 1 0 14.564 0v-15.05c0-.572-.066-1.128-.19-1.662Z",
    fill: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.419 227.806c-10.725 0-19.419 8.694-19.419 19.419v88.356c0 10.725 8.694 19.419 19.419 19.419h143.7c10.725 0 19.419-8.694 19.419-19.419v-88.356c0-10.725-8.694-19.419-19.419-19.419h-143.7Zm93.697 50.489c0 9.583-6.171 17.725-14.755 20.67.124.534.19 1.09.19 1.662v15.05a7.282 7.282 0 1 1-14.564 0v-15.05c0-.572.066-1.128.191-1.662-8.585-2.945-14.755-11.087-14.755-20.67 0-12.065 9.781-21.846 21.846-21.846 12.066 0 21.847 9.781 21.847 21.846Z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.305 121c-34.319 0-62.141 27.821-62.141 62.141v44.663h25.73v-43.207c0-20.645 16.736-37.381 37.382-37.381 20.646 0 37.381 16.736 37.381 37.381v43.207h25.73v-44.663c0-34.32-27.821-62.141-62.14-62.141h-1.942Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.246 147.216c20.646 0 37.382 16.736 37.382 37.381v43.207h25.73v-44.663c0-34.32-27.822-62.141-62.141-62.141h-.971v26.216Z",
    fill: "url(#i)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 256,
    y1: 0,
    x2: 256,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F206F",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 165,
    y1: 238,
    x2: 347.538,
    y2: 238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 165,
    y1: 238,
    x2: 347.538,
    y2: 238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 165,
    y1: 291.403,
    x2: 347.538,
    y2: 291.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 193.164,
    y1: 174.402,
    x2: 319.387,
    y2: 174.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 319.358,
    y1: 227.804,
    x2: 256.246,
    y2: 121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7BD82"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 0 256) scale(226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F206F",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 141,
    y: 97,
    width: 230.539,
    height: 282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1280_4009"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.779e7fd88a43ce97bfec63e3047de70f.svg";
export { ForwardRef as ReactComponent };